/* eslint-disable no-multi-assign,no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-expressions */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').factory('Designer', [
    '$rootScope',
    '$window',
    'DesignerStage',
    'DesignerPackage',
    'DesignerMap',
    'DesignerHistory',

    function ($rootScope, $window, DesignerStage, DesignerPackage, DesignerMap, DesignerHistory) {
      function Designer(data) {
        this.width = 0;
        this.height = 0;
        this.initiated = false;

        this.element;
        this.stage = new DesignerStage(this);
        this.history = new DesignerHistory(this);
        this.package = new DesignerPackage(data, this);
        this.map = new DesignerMap(this);

        this.scrollTop = 0;
        this.scrollLeft = 0;

        this.firefox = $window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        this.initiated = true;
      }

      Designer.prototype.setElement = function (element) {
        this.element = element;
        this.$scroll = element.find('.designer-scroll');
        this.$svg = element.find('.designer-svg');

        this.initEvents();

        const $parent = this.element.parent();

        this.setSize({
          width: $parent.width(),
          height: window.innerHeight,
        });

        this.package.setSize();
      };

      Designer.prototype.moveScroll = function (scrollTop, scrollLeft) {
        this.$scroll.scrollTop(scrollTop);
        this.$scroll.scrollLeft(scrollLeft);
      };

      Designer.prototype.setScroll = function (scrollTop, scrollLeft) {
        this.scrollTop = scrollTop;
        this.scrollLeft = scrollLeft;

        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SCROLL, {
          top: scrollTop,
          left: scrollLeft,
        });
      };

      Designer.prototype.initEvents = function () {
        const _this = this;

        this.$scroll.on('scroll', function () {
          _this.setScroll(_this.$scroll.scrollTop(), _this.$scroll.scrollLeft());
        });
      };

      Designer.prototype.setSize = function (size) {
        this.width = size.width;
        this.height = size.height;
        this.element.css(size);
        this.$scroll.css(size);
      };

      Designer.prototype.getSize = function () {
        return {
          width: this.width,
          height: this.height,
        };
      };

      Designer.prototype.getScrollPosition = function () {
        return {
          top: this.scrollTop,
          left: this.scrollLeft,
        };
      };

      Designer.prototype.save = function (successCallback) {
        this.package.prepareData();

        const data = this.package.getData();

        this.package._lastSavedPackageData = $rootScope._lastSavedPackageData = data;
        this.package.dataChanged = false;

        if (successCallback) data.successCallback = successCallback;

        $rootScope.$broadcast(DESIGNER_EVENTS.SAVE, data);
        $rootScope.$broadcast(DESIGNER_EVENTS.HISTORY_CHANGE, {
          hasUndo: this.history.hasUndo(),
          hasRedo: this.history.hasRedo(),
          packageDataChanged: false,
        });
        $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATED);
      };

      Designer.prototype.undo = function () {
        this.history.undo();
      };
      Designer.prototype.redo = function () {
        this.history.redo();
      };
      Designer.prototype.cut = function () {
        this.package.copySelectedComponents();
        this.package.deleteSelectedComponents();
      };
      Designer.prototype.copy = function () {
        this.package.copySelectedComponents();
      };
      Designer.prototype.paste = function () {
        this.package.pasteSelectedComponents();
      };
      Designer.prototype.unselect = function () {};
      Designer.prototype.fullscreen = function () {};

      return Designer;
    },
  ]);
})(window.angular);
